import React from 'react';
import { connect } from 'react-redux';

import { NotificationController } from 'rhombus-react';
import { removeNotification } from 'reducers/Notifications';

export class Notify extends React.Component{

	render(){
		return (
			<NotificationController
				messages = {this.props.messages}
				onExit   = {this.props.removeNotification}
			/>
		);
	}

}

function mapStateToProps(state){
	return {
		messages: state.notifications.messages.toJS(),
	};
}

function mapDispatchToProps(dispatch){
	return {
		removeNotification(payload){
			return dispatch(removeNotification(payload));
		},
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(Notify);
